/**
 * Security Configuration for react-js
 * Iframe and token communication security settings
 */

// Base URL for the Insider Plus iframe app
// Set REACT_APP_INSIDER_PLUS_URL in your .env to override (e.g. http://localhost:3003)
export const INSIDER_PLUS_BASE_URL =
  process.env.REACT_APP_INSIDER_PLUS_URL ||
  process.env.REACT_APP_LOVABLE_ORIGIN ||
  'https://gs-insiders.lovable.app';

/**
 * Get the target origin for postMessage
 * Derived from the Insider Plus base URL so it always matches the iframe
 */
export const getTargetOrigin = () => {
  try {
    return new URL(INSIDER_PLUS_BASE_URL).origin;
  } catch {
    return INSIDER_PLUS_BASE_URL;
  }
};

// Allowed iframe origins for postMessage
export const ALLOWED_IFRAME_ORIGINS = [
  // The configured insider plus origin
  getTargetOrigin(),

  // Development - Only in development mode
  ...(process.env.NODE_ENV === 'development'
    ? [
        'http://localhost:5173',
        'http://localhost:5174',
        'http://localhost:8080',
        'http://localhost:3003',
      ]
    : []),
];

/**
 * Validate if origin is allowed to receive messages
 */
export const isIframeOriginAllowed = (origin) =>
  ALLOWED_IFRAME_ORIGINS.includes(origin);
